export default __webpack_public_path__ + "0a74ec99739156b2b4cca0ecbb2d9cbc.jpeg";